<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header">{{title}}</span>
  </div>
  <div class="change-association__document-info-container">
    <span [class]="'common-icon__md ' + (document.extension | extensionDocument:'md')"></span>
    <p class="change-association__document-name">{{document.name}}</p>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <field-type-list-simple
        [field]="processSteps"
        [listValues]="listSelectShow"
        [preSelectItem]="stateId"
        (itemSelected)="selectProcess($event)">
      </field-type-list-simple>
    </div>
  </div>

  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">
        _cancelar
      </span>
    </button>
    <button class="common-button__text"
      (click)="changeAssociated()">
      <span class="common-button__text-title"
        [afTranslate]="'common.associate'">
        _asociar
      </span>
    </button>
  </div>
</div>
